export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Aprl",
  "May",
  "June",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

export const formatDate = (date: string) => {
  if (!date) {
    return "";
  }
  // const [dateString] = String(date).split(' ');

  const theDate = new Date(date);
  const month = MONTHS[theDate.getMonth()];
  const year = theDate.getFullYear();
  const dateVal = theDate.getDate();

  return `${month || ""} ${dateVal || ""}, ${year || ""}`;
};
export const formatToString = (date: string) => {
  if (!date) {
    return "";
  }
  // const [dateString] = String(date).split(' ');

  const theDate = new Date(date);
  const month = theDate.getMonth();
  const year = theDate.getFullYear();
  const dateVal = theDate.getDate();

  return `${month || ""}${dateVal || ""}${year || ""}`;
};

export const cleanNumber = (number: string | number) => {
  if (String(number).includes(",")) {
    return String(number).split(",").join("");
  }
  return number;
};
export const formatCurrency = (num: string | number) => {
  if (!num) {
    return 0;
  }
  const cleanNum = cleanNumber(num.toString());
  const numb = Number(cleanNum);
  return String(numb.toFixed(0)).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
export const nairaSymbol = "₦";

export const getDoubleValuDate = (date: number) => {
  return String(date).length < 2 ? `0${date}` : date;
};
export const get12HoursTime = (hour: number, min: number) => {
  if (!hour) {
    return "";
  }
  if (hour === 0 || String(hour) === "0") {
    return `12:${getDoubleValuDate(min)} AM`;
  }
  if (hour === 12) {
    return `12:${getDoubleValuDate(min)} PM`;
  }
  if (hour > 12) {
    return `${getDoubleValuDate(hour - 12)}:${getDoubleValuDate(min)} PM`;
  } else {
    return `${getDoubleValuDate(hour)}:${getDoubleValuDate(min)} AM`;
  }
};
export const getTimeFromDate = (dateTime: string): [number, number] => {
  // if (!dateTime) return ''
  const date = new Date(dateTime);
  return [date.getHours(), date.getMinutes()];
};
export const get12HoursTimeFromDateTime = (dateTime: string) => {
  if (!dateTime) {
    return "";
  }

  const [hour, min] = getTimeFromDate(dateTime);

  const time = get12HoursTime(hour, min);

  return time;
};
export const getParseTime = (date: string) => {
  // return ""
  if (!date) {
    return "";
  }
  return get12HoursTimeFromDateTime(date);
};

export const truncateWords = (word: string, length: number): string => {
  if (!word) return "";
  if (word.length <= length) {
    return word;
  }

  const truncateWord = `${word.substring(0, length)}`;

  return truncateWord.concat("...");
};

export const timeSince = (date: Date) => {
  const currentDate = new Date();
  // @ts-expect-error ignore
  const dateDiff = currentDate - date;
  const seconds = Math.floor(dateDiff / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval).toString() + " years";
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval).toString() + " months";
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval).toString() + " days";
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval).toString() + " hrs";
  }
  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval).toString() + " mins";
  }
  return Math.floor(seconds).toString() + " secs";
};

export const formatAmountInput = (num: number | string | undefined) => {
  if (!num) return 0;
  const cleanNum = cleanNumber(num.toString());
  const numb = Number(cleanNum);
  return String(numb).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
};
